import Api from "@/services/api";

export default {
    login(user) {
        return Api(false).post("/token", user).then(res => res.data);
    },
}
